"use client";

type StructuredDataProps = {
  data: object;
};
export const StructuredData = ({ data }: StructuredDataProps) => {
  if (!data) return null;
  return (
    <script
      type="application/ld+json"
      suppressHydrationWarning
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data).replace(/</g, "\\u003c"),
      }}
    />
  );
};
